import { createReducer, on } from '@ngrx/store';
import { initialState, SessionState } from './session.state';
import { SessionActions } from './session.actions';
import { DateTime } from 'luxon';
import { environment } from '@environment/environment';

export const reducer = createReducer(
	initialState,
	on(SessionActions.login.setup.success, (state, { payload }) => {
		return {
			...state,
			data: {
				...state?.data,
				user: payload.user,
				account: payload.account,
				products: payload.products,
			},
			settings: {
				...state?.settings,
				user: payload.userSettings,
				account: payload.accountSettings,
				notifications: payload.notificationSettings,
			},
			loggedIn: true,
			nextUpdate: DateTime.utc().plus({ minute: environment.redux.sessionUpdateMinutes }).toJSON(),
		};
	}),
	on(SessionActions.logout.start, (state) => {
		return {
			...state,
			data: null,
			settings: null,
			loggedIn: false,
		};
	}),
	on(SessionActions.validate.fail, (state) => {
		return <SessionState>{
			...state,
			data: null,
			settings: null,
			loggedIn: false,
		};
	})
);
